import Navbar from "../general/navbar";
import Hero from "../main/hero";
import About from "../main/about";
import Awakening from "../main/awakening";
import Contact from "../main/contact.jsx";
import ImageCarousel from "../general/imageCarousel";
import Footer from "../general/footer";

export default function IndexPage() {
  return (
    <div className="main-page">
      <Navbar />
      <Hero />
      <About />
      <Awakening />
      <Contact />
      <ImageCarousel />
      <Footer />
    </div>
  );
}
